import { render, staticRenderFns } from "./globalTooltip.vue?vue&type=template&id=1fcd0615&scoped=true"
import script from "./globalTooltip.vue?vue&type=script&lang=js"
export * from "./globalTooltip.vue?vue&type=script&lang=js"
import style0 from "./globalTooltip.vue?vue&type=style&index=0&id=1fcd0615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd0615",
  null
  
)

export default component.exports